import { parseLocalDate, getLocalDateString } from './dateUtils';

// How many cards Coming up renders, and how many of them are held for
// invites. Without the reservation, a user with a few planned weekends would
// never see an invite dated after them — the strip is date-ordered and capped.
export const COMING_UP_LIMIT = 10;
export const INVITE_SLOTS = 3;

/** The date an invite sits at in the timeline (dateless → now, like a dateless trip). */
export function inviteSortDate(invite) {
  const date = invite.type === 'trip' ? invite.start_date : invite.scheduled_date;
  return date ? parseLocalDate(date) : new Date();
}

/**
 * Is this invite still ahead of (or on) the user's local today? The server
 * cuts a day early because it only knows UTC; this is the exact cut, in the
 * user's own calendar. A trip counts until its last day; dateless stays.
 */
export function isInviteCurrent(invite, today = getLocalDateString(new Date())) {
  const ref = invite.type === 'trip'
    ? invite.end_date || invite.start_date
    : invite.scheduled_date;
  return !ref || ref.slice(0, 10) >= today;
}

/**
 * Merge confirmed plans with pending invites into the Coming up strip.
 *
 * `confirmed` are already-tagged trip/activity items with `_sortDate`;
 * `invites` come from /api/invitations/pending, soonest first. The nearest
 * INVITE_SLOTS invites always get a card; confirmed plans fill the rest, and
 * everything is shown in date order. Invites past the reserved slots still
 * reach the user through the header chip and the invite list.
 *
 * An invite for a trip that is ALSO a confirmed card (you're going, your
 * child's invitation is still open) doesn't get a second card for the same
 * trip — it stays in the chip and the list.
 */
export function buildComingUpItems(confirmed, invites) {
  const confirmedTripIds = new Set(
    confirmed.filter(i => i._cardType === 'trip').map(i => i.id)
  );
  const inviteItems = invites
    .filter(inv => !(inv.type === 'trip' && confirmedTripIds.has(inv.id)))
    .slice(0, INVITE_SLOTS)
    .map(inv => ({ ...inv, _cardType: 'invite', _sortDate: inviteSortDate(inv) }));

  const sorted = [...confirmed].sort((a, b) => a._sortDate - b._sortDate);
  return [...inviteItems, ...sorted.slice(0, COMING_UP_LIMIT - inviteItems.length)]
    .sort((a, b) => a._sortDate - b._sortDate);
}
